import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
const SocialProof = lazy(() => import('./components/SocialProof').then(m => ({
  default: m.SocialProof
})));
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const ProductBreakdown = lazy(() => import('./components/ProductBreakdown').then(m => ({
  default: m.ProductBreakdown
})));
const WhyChoose = lazy(() => import('./components/WhyChoose').then(m => ({
  default: m.WhyChoose
})));
const Countdown = lazy(() => import('./components/Countdown').then(m => ({
  default: m.Countdown
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const DetailedTestimonials = lazy(() => import('./components/DetailedTestimonials').then(m => ({
  default: m.DetailedTestimonials
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
export function App() {
  useEffect(() => {
    // Preload hero image for faster LCP
    const imgLink = document.createElement('link');
    imgLink.rel = 'preload';
    imgLink.as = 'image';
    imgLink.href = 'https://cdn.magicpatterns.com/uploads/sResd856pT4nEBtm8skGQ7/fisica_en_accion_mockup_optimized.webp';
    document.head.appendChild(imgLink);
    // Preconnect to Facebook for Meta Pixel
    const fbLink = document.createElement('link');
    fbLink.rel = 'preconnect';
    fbLink.href = 'https://connect.facebook.net';
    document.head.appendChild(fbLink);
  }, []);
  return <main className="w-full min-h-screen" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <Suspense fallback={<div className="h-20" data-id="element-4" />} data-id="element-3">
        <SocialProof data-id="element-5" />
        <PainPoints data-id="element-6" />
        <ProductBreakdown data-id="element-7" />
        <WhyChoose data-id="element-8" />
        <Countdown data-id="element-9" />
        <Pricing data-id="element-10" />
        <DetailedTestimonials data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
        <Footer data-id="element-14" />
      </Suspense>
    </main>;
}